export default __webpack_public_path__ + "static/media/affiliate-feature-unlimited.bd3a9ec8.svg";